import { render, staticRenderFns } from "./ReviewContract.vue?vue&type=template&id=1111392c&"
import script from "./ReviewContract.vue?vue&type=script&lang=js&"
export * from "./ReviewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports